// pro brand icons (fab)
import { faWpforms, faGithubAlt } from '@fortawesome/free-brands-svg-icons';

export default (library) => {
    library.add(faWpforms, faGithubAlt);
};
